export default {
    // Cotacao, leitura ou gravacao do frete em andamento. O checkout segura o
    // "Finalizar" enquanto isso: a request que termina depois do /payment/execute
    // regrava a sessao antiga por cima da que o pedido limpou.
    isShippingBusy: (state) => state.pendingRequests > 0,
    getCorreios: (state) => state.shippings.correio,
    getRodonaves: (state) => state.shippings.rodonaves,
    getFflipFretes: (state) => state.shippings.fflip_fretes ?? [],
    getMelhorEnvio: (state) => state.shippings.melhor_envio,
    getJamef: (state) => state.shippings.jamef,
    getJadlog: (state) => state.shippings.jadlog,
    getAcExpress: (state) => state.shippings.ac_express,
    getAceville: (state) => state.shippings.aceville,
    getBraspress: (state) => state.shippings.braspress,
    getBauer: (state) => state.shippings.bauer,
    getExpressoSaoMiguel: (state) => state.shippings.expresso_sao_miguel,
    getZanotelli: (state) => state.shippings.zanotelli,
    getTNT: (state) => state.shippings.tnt,
    getTodoBrasil: (state) => state.shippings.todo_brasil,
    getAcevilleTdaTde: (state) => state.shippings.transp_aceville,
    getAzurelog: (state) => state.shippings.azurelog,
    getEbTrans: (state) => state.shippings.ebtrans,
    getRodovitor: (state) => state.shippings.rodovitor,
    getAgex: (state) => state.shippings.agex,
    getFariasFaz: (state) => state.shippings.farias_faz,
    getScLogistica: (state) => state.shippings.sc_logistica,
    getAlfa: (state) => state.shippings.alfa,
    getAtiva: (state) => state.shippings.ativa,
    getTotalExpress: (state) => state.shippings.total_express,
}
